const offerParams = {
    ADVANTAGE: 'УТП',
    AGE_FROM: 'Возраст от',
    AGE_TO: 'Возраст до',
    AMOUNT_FROM: 'Сумма от',
    AMOUNT_TO: 'Сумма до',
    APPROVAL_RATE: '% одобрения',
    CASHBACK: 'Кэшбэк',
    CREDIT_LIMIT: 'Кредитный лимит',
    DEPOSIT: 'Залог',
    INCOME: 'Оплата',
    INITIAL_PAYMENT: 'Первый взнос',
    INTEREST_FREE_PERIOD: 'Льготный период',
    INTEREST_ON_ACCOUNT: '% на остаток',
    INTEREST_RATE_FROM: 'Ставка от',
    INTEREST_RATE_TO: 'Ставка до',
    MAINTENANCE: 'Обслуживание',
    PERIOD_FROM: 'Срок от',
    PERIOD_TO: 'Срок до',
    POSITION: 'Должность',
    WORK_SCHEDULE: 'График работы',
    BONUS_TO: 'Бонус до',
    RATING_BETTING: 'Рейтинг беттинг',
    MIN_DEP: 'Минимальный депозит',
    BETTING_DESCRIPTION: 'Описание',
    APPROVAL_LEVEL: 'Одобрение',
    RATING_OFFER: 'Рейтинг',
    DEPOSIT_PERCENT: 'Процент по вкладу',
    RKO_TRANSFERS_TO_LEGAL_ENTITIES: 'Переводы юр. лицам',
    RKO_CASH_WITHDRAWAL_FEE: 'Комиссия за снятие наличных',
    RKO_TARIFF_COST: 'Стоимость тарифа',
};

export default {
    [offerParams.AMOUNT_FROM]: {
        key: 'amount',
        label: 'Сумма',
        pKey: 'start',
    },
    [offerParams.AMOUNT_TO]: {
        key: 'amount',
        label: 'Сумма',
        pKey: 'end',
    },
    [offerParams.AGE_FROM]: {
        key: 'age',
        label: 'Возраст',
        pKey: 'start',
    },
    [offerParams.AGE_TO]: {
        key: 'age',
        label: 'Возраст',
        pKey: 'end',
    },
    [offerParams.PERIOD_FROM]: {
        key: 'period',
        label: 'Срок',
        pKey: 'start',
    },
    [offerParams.PERIOD_TO]: {
        key: 'period',
        label: 'Срок',
        pKey: 'end',
    },
    [offerParams.INTEREST_RATE_FROM]: {
        key: 'rate',
        label: 'Ставка',
        pKey: 'start',
    },
    [offerParams.INTEREST_RATE_TO]: {
        key: 'rate',
        label: 'Ставка',
        pKey: 'end',
    },
    [offerParams.APPROVAL_RATE]: {
        key: 'approval',
        label: 'одобряет от',
        pKey: 'single',
    },
    [offerParams.INTEREST_FREE_PERIOD]: {
        key: 'freePeriod',
        label: 'Льготный период',
        pKey: 'single',
    },
    [offerParams.ADVANTAGE]: {
        key: 'advantage',
        label: '',
        pKey: 'single',
    },
    [offerParams.INITIAL_PAYMENT]: {
        key: 'initialPayment',
        label: 'Первый взнос',
        pKey: 'single',
    },
    [offerParams.CASHBACK]: {
        key: 'cashback',
        label: 'Кэшбэк',
        pKey: 'single',
    },
    [offerParams.CREDIT_LIMIT]: {
        key: 'creditLimit',
        label: 'Кредитный лимит',
        pKey: 'single',
    },
    [offerParams.DEPOSIT]: {
        key: 'deposit',
        label: 'Залог', // ? перевод
        pKey: 'single',
    },
    [offerParams.INCOME]: {
        key: 'income',
        label: 'Оплата',
        pKey: 'single',
    },
    [offerParams.POSITION]: {
        key: 'position',
        label: 'Должность',
        pKey: 'single',
    },
    [offerParams.WORK_SCHEDULE]: {
        key: 'workSchedule',
        label: 'График работы',
        pKey: 'single',
    },
    [offerParams.MAINTENANCE]: {
        key: 'maintenance',
        label: 'Обслуживание',
        pKey: 'single',
    },
    [offerParams.INTEREST_ON_ACCOUNT]: {
        key: 'interestOnAccount', // ? перевод
        label: '% на остаток',
        pKey: 'single',
    },
    [offerParams.BONUS_TO]: {
        key: 'bonusTo',
        label: 'Бонус до',
        pKey: 'single',
    },
    [offerParams.RATING_BETTING]: {
        key: 'ratingBetting',
        label: 'Рейтинг',
        pKey: 'single',
    },
    [offerParams.MIN_DEP]: {
        key: 'minDep',
        label: 'Минимальный депозит',
        pKey: 'single',
    },
    [offerParams.BETTING_DESCRIPTION]: {
        key: 'bettingDescription',
        label: 'Описание',
        pKey: 'single',
    },
    [offerParams.APPROVAL_LEVEL]: {
        key: 'approvalLevel',
        label: 'Одобрение',
        pKey: 'single',
    },
    [offerParams.RATING_OFFER]: {
        key: 'ratingOffer',
        label: 'Рейтинг',
        pKey: 'single',
    },
    [offerParams.DEPOSIT_PERCENT]: {
        key: 'depositPercent',
        label: '% по вкладу',
        pKey: 'single',
    },
    [offerParams.RKO_TRANSFERS_TO_LEGAL_ENTITIES]: {
        key: 'rkoTransfers',
        label: 'Переводы юр. лицам',
        pKey: 'single',
    },
    [offerParams.RKO_CASH_WITHDRAWAL_FEE]: {
        key: 'rkoCash',
        label: 'Снятие наличных',
        pKey: 'single',
    },
    [offerParams.RKO_TARIFF_COST]: {
        key: 'rkoTariffCost',
        label: 'Стоимость тарифа',
        pKey: 'single',
    },
};
